export const isFieldEmpty = (field?: string | number | null) =>
  field === '' || field === null || field === undefined;
